import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Injector,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { SmartFiltersSectionViewModel } from './smart-filters-section-view-model';
import { BaseComponent } from '../../../../models/base/base-component';
import { take } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SmartDataType } from '../../../../models/enum/shared/smart-data-type.enum';
import { exists } from '../../../../functions/exists';
import { ModalSelectSmartFilter } from '../../../../modals/modal-select-smart-filter';

@Component({
  selector: 'app-smart-filters-section',
  templateUrl: './smart-filters-section.component.html',
  styleUrls: ['./smart-filters-section.component.scss'],
  providers: [SmartFiltersSectionViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SmartFiltersSectionComponent extends BaseComponent implements OnChanges {
  @Input() smartDataType: SmartDataType = SmartDataType.Badges;
  @Input() smartFilterIds: string[] = [];
  @Output() smartFiltersAdded = new EventEmitter<string[]>();
  @Output() smartFilterRemoved = new EventEmitter<string>();

  constructor(
    public viewModel: SmartFiltersSectionViewModel,
    protected ngZone: NgZone,
    protected ngbModal: NgbModal,
    protected injector: Injector
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.smartFilterIds) {
      this.viewModel.setSmartFilterIds(this.smartFilterIds);
    }
  }

  openSmartFilterModal(): void {
    this.viewModel.smartFilterIds$.pipe(take(1)).subscribe(previouslySelectedIds => {
      ModalSelectSmartFilter.open(
        this.ngZone,
        this.ngbModal,
        this.injector,
        previouslySelectedIds,
        this.emitSmartFiltersAdded.bind(this)
      );
    });
  }

  private emitSmartFiltersAdded(ids: string[]): void {
    if (exists(ids)) this.smartFiltersAdded.emit(ids);
  }
}
